import React from 'react'
import {Modal,ModalHeader,ModalBody,ModalFooter,Button} from 'reactstrap'
import {connect} from 'react-redux'
import { withSiteData } from 'react-static'
import Invoice from '../components/Invoice'
import Spinner from '../components/Spinner'

class ShowInvoice extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = (e) => {
    if(e) e.preventDefault()
    this.setState({show: !this.state.show})
  }

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/orders')
  }

  render(){
    return(
      <Modal
        size='lg'
        isOpen={this.state.show}
        onClosed={this.restoreUrl}
        toggle={this.close}>
        <ModalHeader toggle={this.close}>PDF</ModalHeader>
        <ModalBody>
          {this.props.order && this.props.companyData && !this.props.isFetching
            ?
            <Invoice order={this.props.order} companyData={this.props.companyData}/>
            :
            <Spinner/>
          }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.close}>Schliessen</Button>
        </ModalFooter>
      </Modal>
    )
  }
}


export default connect(
  (state,ownProps) => {
    const order = state.orders.items.find(o => o.id===ownProps.match.params.id)
    const account = state.account.accessibleAccounts.find(a =>
      a.id===state.account.currentAccountId
    )
    const companyData = (account && account.company) || {}

    return {
      order,
      companyData,
      isFetching: !order || !account
    }
  },
  dispatch => ({})
)(withSiteData(ShowInvoice))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/ShowInvoice.js